module.exports = __webpack_public_path__ + "img/content5-5.060d1f76.webp";